<template>
   <vs-input
      ref="inputRef"
      :label="label"
      :icon-pack="iconPack || 'feather'"
      :icon="icon || 'icon-dollar-sign'"
      :class="styleClass"
      :name="name"
      :disabled="disabled"
    />
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input'

export default {
  name: 'VxCurrencyInput',
  props: {
    value: String | Number,
    styleClass: String,
    label: String,
    iconPack: String,
    icon: String,
    name: String,
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => {
        return {
          currency: 'USD',
          currencyDisplay: 'hidden',
          useGrouping: true,
          precision: 2
        }
      }
    }
  },
  setup (props) {
    const { inputRef } = useCurrencyInput(props.options)
    return { inputRef }
  }
}
</script>
